/* eslint-disable no-unused-vars */
import React from 'react';
// import Box from '@material-ui/core/Box';
// import InspirationIcon from 'assets/ssc_inspiration.png';
import TrendIcon from 'assets/ssc_trend.png';
import coupon from 'assets/coupon.png';
// import SuccessIcon from 'assets/ssc_success.png';
// import PurchaseIcon from 'assets/ssc_purchase.png';
import HintCard from './HintCard';
// import ContentTypography from '../../../Common/ContentTypography';
import Styles from './index.module.css';

function HintDashboard() {
  return (
    <div className={Styles.hintDashboardContainer}>
      <div className={Styles.hintDashboardCard}>
        {/* <HintCard src={coupon} href="https://www.hhgalaxy.com.tw/qa/95#354">最新優惠</HintCard> */}
        <HintCard src={TrendIcon} href="https://www.hhgalaxy.com.tw/qa/92">查看最新趨勢</HintCard>
      </div>
    </div>
  );
}

export default HintDashboard;
